<template>
  <g fill-rule="evenodd">
    <path
      d="M8.7 2a3.88 3.88 0 110 7.75A3.88 3.88 0 018.7 2M17.4 3.87a2.89 2.89 0 110 5.78 2.89 2.89 0 010-5.78M23.15 16.48c-.58-3.63-2.48-5.81-5.74-5.81-1.26 0-2.28.3-3.13.92.1.1.2.2.34.3 1.4 1.47 2.34 3.57 2.79 6.26 0 .1.03.2.03.27 3.16.04 5.95-.5 5.71-1.94M8.7 20.97c-4.25 0-7.99-.75-7.68-2.62.81-4.9 3.36-7.75 7.68-7.75s6.87 2.9 7.69 7.75c.3 1.87-3.44 2.62-7.69 2.62"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MultipleUsersIcon",
});
</script>
